var redefine = require('./$.redefine');
module.exports = function(target, src){
  for(var key in src)redefine(target, key, src[key]);
  return target;
};


//////////////////
// WEBPACK FOOTER
// D:/midea_porject/php/htdocs/~/core-js/library/modules/$.redefine-all.js
// module id = 67
// module chunks = 0